import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";

export interface GenerateLead extends GtagEvent {
    currency:ISO_4217;
    value: number;
    lead_source?:string;
}
export const generate_lead = ($_:GenerateLead) => event('generate_lead',$_);